<template>
  <div class="flex flew-row">
    <NumericInput
      :value="localWeightInKg"
      min="0"
      max="680"
      aria-label="kg"
      inputId="weightMajor"
      :input-style="inputStyle"
      :measurement-indicator="measurementIndicators.kilograms"
      @input="localWeightInKg = $event"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { validateInput } from "../../SimpleBmiQuestion/validation";
import NumericInput from "./NumericInput.vue";
import { MetricWeightMeasurementIndicators } from "../../../types";

export default Vue.extend({
  components: { NumericInput },
  props: {
    weightInKg: { type: Number, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicators: { type: Object as PropType<MetricWeightMeasurementIndicators>, required: true },
  },
  computed: {
    localWeightInKg: {
      get() {
        return this.weightInKg;
      },
      set(value) {
        const emitValue = validateInput(value, 680);
        this.$emit("update:weightInKg", emitValue);
      },
    },
  },
});
</script>
